<template>
  <div
    id="product-safety-modal"
    ref="modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title h3">
            {{
              $translate(
                "modeherz::SingleItemPageClient.itemProductSafetyHeader"
              )
            }}
          </div>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            &times;
          </button>
        </div>
        <div v-if="!productSafetyLoaded" class="modal-body">
          <loading-animation class="" />
        </div>
        <div v-else class="modal-body p-4">
          <h4 class="mb-3">
            {{
              $translate(
                "modeherz::SingleItemPageClient.itemProductSafetyManufacturerDescription"
              )
            }}
          </h4>
          <template v-if="manufacturer">
            {{ manufacturer.name }}<br />
            {{ manufacturer.addressLine1 }}<br />
            <template v-if="manufacturer.addressLine2">
              {{ manufacturer.addressLine2 }}<br />
            </template>
            {{ manufacturer.countryCode }}
            {{ manufacturer.zipCode }} {{ manufacturer.city }}<br />
            <template v-if="manufacturer.email">
              <i class="far fa-envelope mr-1"></i>{{ manufacturer.email }}<br />
            </template>
            <template v-if="manufacturer.phone">
              <i class="far fa-phone-alt fa-flip-horizontal mr-1"></i
              >{{ manufacturer.phone }}<br />
            </template>
            <template v-if="manufacturer.contactUrl">
              <i class="fa fa-sign-out mr-1"></i>{{ manufacturer.contactUrl
              }}<br />
            </template>
          </template>
          <template v-else>
            <i>
              {{
                $translate(
                  "modeherz::SingleItemPageClient.itemProductSafetyManufacturerNotAvailable"
                )
              }}
            </i>
          </template>
          <br />
          <br />
          <h4 class="mb-3">
            {{
              $translate(
                "modeherz::SingleItemPageClient.itemProductSafetyEuResponsibleDescription"
              )
            }}
          </h4>
          <template v-if="euResponsiblePerson">
            {{ euResponsiblePerson.name }}<br />
            {{ euResponsiblePerson.addressLine1 }}<br />
            <template v-if="euResponsiblePerson.addressLine2">
              {{ euResponsiblePerson.addressLine2 }}<br />
            </template>
            {{ euResponsiblePerson.countryCode }}
            {{ euResponsiblePerson.zipCode }} {{ euResponsiblePerson.city
            }}<br />
            <template v-if="euResponsiblePerson.email">
              <i class="far fa-envelope mr-1"></i>{{ euResponsiblePerson.email
              }}<br />
            </template>
            <template v-if="euResponsiblePerson.phone">
              <i class="far fa-phone-alt fa-flip-horizontal mr-1"></i
              >{{ euResponsiblePerson.phone }}<br />
            </template>
            <template v-if="euResponsiblePerson.contactUrl">
              <i class="fa fa-sign-out mr-1"></i
              >{{ euResponsiblePerson.contactUrl }}<br />
            </template>
          </template>
          <template v-else>
            <i>
              {{
                $translate(
                  "modeherz::SingleItemPageClient.itemProductSafetyEuResponsibleNotAvailable"
                )
              }}
            </i>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductSafetyModal",
  props: {
    variationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      productSafety: null,
      euResponsiblePerson: null,
      manufacturer: null,
      productSafetyLoaded: false,
    };
  },
  mounted() {
    $(this.$refs.modal).on("show.bs.modal", this.loadProductSafety);
  },
  methods: {
    loadProductSafety() {
      if (this.productSafety == null) {
        const self = this;
        $.ajax({
          type: "GET",
          url:
            "/rest/modeherz/shop/product_safety/eu_representative?variationId=" +
            this.variationId,
          success: (response) => {
            if (typeof response === "string") {
              response = JSON.parse(response);
            }
            self.productSafety = response;
            self.euResponsiblePerson = response.euResponsiblePerson;
            self.manufacturer = response.manufacturer;
            self.productSafetyLoaded = true;
            this.$emit("data:loaded", { productSafety: response });
          },
          error: function (jqXHR, textStatus, errorThrown) {
            self.productSafetyLoaded = true;
            console.error(errorThrown);
          },
        });
      }
    },
    setProductSafety(productSafety) {
      this.productSafety = productSafety;
    },
  },
};
</script>

<style scoped></style>
